import React from 'react';
import { Container, Row, Col, FormGroup, FormInput, ModalBody } from 'shards-react';
import Select from 'react-select';
import OptionsTypeCheckboxes from '../../common/OptionsTypeCheckboxes';
import type { SteelMaker, BusinessType, SteelCategory } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

interface ModalEditBodyProps {
  labelBase: string;
  base: OptionsType;
  optionsBase: OptionsType<string>[];
  placeholderBase: string;
  getOptionLabel: (option: OptionsType) => string;
  getOptionValue: (option: OptionsType) => string;
  onChangeBase: (option: OptionsType | null) => void;

  labelName: string;
  name: string;
  invalidName: boolean;
  onChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;

  labelSteelMaker: string;
  optionsSteelMaker: OptionsType<SteelMaker>[];
  selectedSteelMaker: SteelMaker[];
  onChangeSteelMaker: (codes: SteelMaker[]) => void;

  labelBusinessType: string;
  optionsBusinessType: OptionsType<BusinessType>[];
  selectedBusinessType: BusinessType[];
  onChangeBusinessType: (codes: BusinessType[]) => void;

  labelSteelCategory: string;
  optionsSteelCategory: OptionsType<SteelCategory>[];
  selectedSteelCategory: SteelCategory[];
  onChangeSteelCategory: (codes: SteelCategory[]) => void;
}

const ModalEditBody = ({
  labelBase,
  base,
  optionsBase,
  placeholderBase,
  getOptionLabel,
  getOptionValue,
  onChangeBase,

  labelName,
  name,
  invalidName,
  onChangeName,

  labelSteelMaker,
  optionsSteelMaker,
  selectedSteelMaker,
  onChangeSteelMaker,

  labelBusinessType,
  optionsBusinessType,
  selectedBusinessType,
  onChangeBusinessType,

  labelSteelCategory,
  optionsSteelCategory,
  selectedSteelCategory,
  onChangeSteelCategory,
}: ModalEditBodyProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(d);
  // }, [d]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <FormGroup>
        <label htmlFor="organizationBase">{labelBase}</label>
        <Select
          id="organizationBase"
          name="organizationBase"
          className="react-select-container mb-3"
          classNamePrefix="react-select"
          value={base}
          options={optionsBase}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          onChange={onChangeBase}
          placeholder={placeholderBase}
        />
        <label htmlFor="name">{labelName}</label>
        <FormInput id="organizationSuffixName" className="mb-3" value={name} invalid={invalidName} onChange={onChangeName} />
        <Container>
          <Row>
            <Col>
              <OptionsTypeCheckboxes label={labelSteelMaker} options={optionsSteelMaker} selectedCodes={selectedSteelMaker} onChangeChecked={onChangeSteelMaker} />
            </Col>
            <Col>
              <OptionsTypeCheckboxes label={labelBusinessType} options={optionsBusinessType} selectedCodes={selectedBusinessType} onChangeChecked={onChangeBusinessType} />
            </Col>
            <Col>
              <OptionsTypeCheckboxes label={labelSteelCategory} options={optionsSteelCategory} selectedCodes={selectedSteelCategory} onChangeChecked={onChangeSteelCategory} />
            </Col>
          </Row>
        </Container>
      </FormGroup>
    </ModalBody>
  );
};

export default ModalEditBody;
